/**
 * 任务指派总路由
 * 2019-05-08
 * Qian.qianchen
 */
"use strict";
angular.module("assignmentsRouterModule", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("front.plan.taskassignment.assignments.allassignments", {
        url: "/allassignments", //所有任务
        views: {
            "main@front.plan.taskassignment.assignments": {
                templateUrl: "./planningCenter/taskAssignment/assignments/allAssignments/allAssignments_tpl.html",
                controller: "allAssignmentsCtrl"
            }
        }
    }).
    state("front.plan.taskassignment.assignments.pendingassignments", {
        url: "/pendingassignments", //待审任务
        views: {
            "main@front.plan.taskassignment.assignments": {
                templateUrl: "./planningCenter/taskAssignment/assignments/pendingAssignments/pendingAssignments_tpl.html",
                controller: "pendingAssignmentsCtrl"
            }
        }
    }).
    state("front.plan.taskassignment.assignments.assignmentedit", { //新建/编辑任务
        url: '/assignmentedit?assignmentid&platform&istrial',
        views: {
            "main@front.plan.taskassignment": {
                templateUrl: "./planningCenter/taskAssignment/editAssignment/editAssignment_tpl.html",
                controller: "editAssignmentCtrl"
            }
        }
    });
}]);